/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomerCardService from 'services/customer-card.service';

export function ConfirmEmail() {
  
  const params = useParams<{ id?: string }>();
  const history = useHistory();
  const [message, setMessage] = useState('Kinnitamine...');

  useEffect(() => {
    if (params.id) {
      CustomerCardService.postIdCreditEmailConfirm(params.id).then(res => {
        if (res.success) {
          setMessage('E-maili aadress kinnitatud! Suuname Teid tagasi avalehele');
          setTimeout(() => {
            history.replace('/');
          }, 5000);
        } else {
          if (res.message === 'EMAIL_EXPIRED') {
            setMessage('E-maili aadressi kinnitamine ebaõnnestus! Möödunud on 14 päeva, palun esitage uus taotlus. Suuname Teid tagasi avalehele');
            setTimeout(() => {
              history.replace('/');
            }, 5000);
          } else {
            history.replace('/');
          }
        }
      })
    }
  }, [params.id]);

  return (
    <div>{message}</div>
  )
}